import EmployeeSkills from './EmployeeSkills';

export default EmployeeSkills;
